import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { states } from "../../Mocks/state";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Iconify from "./Iconify";

const StyledTextField = styled(TextField)({
  "& label, & label.Mui-focused": {
    height: "20px",
    fontSize: "12px",
  },
});

const StyledOptionBox = styled(Box)({
  fontSize: "0.7rem",
});

export default function CardSearch() {
  return (
    <Autocomplete
      variant="outlined"
      clearOnEscape
      disablePortal
      id="combo-box-demo"
      options={states}
      clearIcon={<HighlightOffIcon sx={{ fontSize: "14px" }} />}
      sx={{
        height: 20,
        width: 138,
        fontSize: "5px",
        border:'1px',
        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
          fontSize: 13,
          borderWidth:'1px'
        },
        ".MuiOutlinedInput-notchedOutline": {
          borderRadius: 2,
          borderColor: "#cdc1c1",
          borderWidth:'1px'
        },
        "& label.Mui-focused": {
          color: "white",
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: "#c1c1c1",
          borderWidth:'1px'
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#c1c1c1",
            borderWidth:'1px'
          },
          "&:hover fieldset": {
            borderColor: "#c1c1c1",
            borderWidth:'1px'
          },
          "&.Mui-focused fieldset": {
            borderColor: "#c1c1c1",
            borderWidth:'1px'
          },
       
        },
      }}
      ListboxProps={{
        sx: {
          fontSize: 13,
          // "& li:nth-child(even)": { backgroundColor: "#CCC" },
          // "& li:nth-child(odd)": { backgroundColor: "#FFF" },
          "&::-webkit-scrollbar": {
            width: 5,
            height: 5,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#fff",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#DCDCDC",
            borderRadius: 2,
          },
          "& :hover": {
            color: "#016c34",
          },
          '& .MuiAutocomplete-option[aria-selected="true"]': {  // works
            backgroundColor: '#E1F4EA',
          },
          '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { // works
            backgroundColor: '#C7E5D6',
          },
          '& .MuiAutocomplete-option.Mui-selected': { // doesn't works
            backgroundColor: 'lightRed',
          },
          '& .MuiAutocomplete-option.Mui-selected.Mui-focused': { // doesn't works
            backgroundColor: 'red',
          },
        },
      }}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          placeholder="Choose state"
          variant="outlined"
          size="small"
          InputLabelProps={
            {
              // style: { top: '2px'}
            }
          }
          InputProps={{
            ...params.InputProps,
            style: { fontSize: "5px !important" },
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <StyledOptionBox>{option.label}</StyledOptionBox>
        </li>
      )}
    />
  );
}
